export enum VehicleStatus {
	IN_ERROR,
	MISSING_MANDATORY_DATA,
	PENDING,
	COMPLETED
}
